module.exports = __webpack_public_path__ + "img/03.74562397.png";